import React, { useCallback, useEffect, useState } from 'react'
import MasterComponentWraper from '../../Backend/MasterComponentWraper'
import NavigationHeder from '../../Navigations/NavigationHeder'
import ButtonNew from '../../inc/ButtonNew'
import AgGridNew from '../../grid/ag/ag-grid-new'
import ApiDetailsFormsPopup from './ApiDetailsFormsPopup'
import { useNavigate } from 'react-router-dom'
import Api from '../../../inc/Api'
import Settings from '../../../inc/Settings'
import Helper from '../../../inc/Helper'
import { getPopupMessageBasedOnStatus } from '../../../inc/Validation'
import { getLabelFromDropdown, gridLinkValueFormat } from '../../grid/ag/commonFunctions/GridCommonFunctions'
import DatepickerFunctions from '../../../inc/DatepickerHelper' 
import CommonAPICalls from '../Common Integration Calls/CommonApiCalls'
import SimpleDropdown from '../../grid/ag/cellEditor/SimpleDropdown'

let gridApi = null;
const ApiDetailsFormsListings = () => {
    const [openPopupView, setOpenPopupView] = useState(false); 
    const [appMaster, setAppMaster] = useState([]);

    const navigate = useNavigate();

    useEffect(() => {  
        fetchDataForAppMaster();
    }, [])
    
    const fetchDataForAppMaster = async () => {
        const apiCalls = new CommonAPICalls();
        try {
            const systemAppMasterResponse = await apiCalls.getSystemApiDetails();
            if (systemAppMasterResponse) {
                setAppMaster(systemAppMasterResponse);
            };
        } catch (error) { 
            setAppMaster([]); 
        }
    }

    const onClickRedirectToDetailView = (event) => {   
        if(event.colDef.field === 'title') { 
            navigate(`/edit-lynkaz-api-details/${event?.data?.api_details}`)
        }
    }

    const onClickPopupView = () => {
      setOpenPopupView(true);
    }
  
    const onDeleteIntegrationDocument = useCallback(async (element) => { 
        let api = Api;
        api.setUserToken();
        
        let delDocument_ID = element?.data?.api_details;
    
        try {
            const res = await api
            .axios()
            .delete(Settings.apiAppUrl+`/lynkaz-api/${delDocument_ID}/`)
    
            const rowNode = gridApi?.getRowNode(delDocument_ID)
            
            if (rowNode) {
                rowNode.setSelected(false)
            }
            
            setTimeout(() => {
                const transaction = { remove: [element.data] }
                gridApi?.applyServerSideTransaction(transaction) 
            }, 200);
    
            gridApi?.refreshServerSide({ purge: true })
            gridApi?.deselectAll();
            
            Helper.alert(res?.data?.message || 'Api detail deleted successfully', 'success')
        } catch (err) {
            getPopupMessageBasedOnStatus(err)
        }
    }, []);

    const reloadParentGrid = () => {
        gridApi?.refreshServerSide({ purge: true });
        gridApi?.deselectAll();
    };

    const gridColumnHeaders = [
        {field:'title', headerName:'Title', editable: false, cellRenderer: (params) => gridLinkValueFormat(params) }, 
        {field:'enum_details', headerName:'Enum details',  editable: false },
        {field:'field', headerName:'Field', editable: false },
        {field:'table', headerName:'Table', editable: false },  
        {
            field: 'api',
            headerName: 'Api',
            editable: false, 
            isAllowZero: true,
            cellEditor: SimpleDropdown,
            minWidth: 180,  
            cellEditorParams: {
                values: appMaster
            },
            cellDataType: false,
            valueFormatter: (params) => getLabelFromDropdown(params)
        },    
        {field:'type', headerName:'Type', editable: false },
        {field:'default_value', headerName:'Default value', editable: false }, 
        {
            field: 'reference_api',
            headerName: 'Reference Api',
            editable: false, 
            isAllowZero: true,
            cellEditor: SimpleDropdown,
            minWidth: 180,  
            cellEditorParams: {
                values: appMaster
            },
            cellDataType: false,
            valueFormatter: (params) => getLabelFromDropdown(params)
        },  
        {field:'created_by', headerName:'Created by', editable: false },
        {field:'created_datetime', valueFormatter: (params) => params?.value ? DatepickerFunctions.convertDateTimeFromDataBase(params?.value) : '-', headerName:'Created date time', editable: false },
        {field:'modified_by', headerName:'Modified by', editable: false },
        {field:'modified_datetime', valueFormatter: (params) => params?.value ? DatepickerFunctions.convertDateTimeFromDataBase(params?.value) : '-', headerName:'Modified date time', editable: false }
    ];

    return (
        <div className='container-fluid'>
            <NavigationHeder hideMoreBtn={true} backUrl='/system-integration' title={'Lynkaz API Detail'}>
                <ButtonNew onClick={onClickPopupView} title={'New'}  />
            </NavigationHeder>
                
            <AgGridNew
                apiUrl={Settings.apiAppUrl+'/lynkaz-api'} 
                pagination={false}
                columnDefs={gridColumnHeaders}
                hideAddBtn={true}
                height={500}
                uniqueField={'api_details'}
                onCellClicked={onClickRedirectToDetailView}
                handleDeleteSelectedRows={onDeleteIntegrationDocument}
                onGridReady={(params) => gridApi = params?.api} 
                gridId={"api_details_forms_listing_grid"}
            />
    
            {openPopupView && <ApiDetailsFormsPopup reloadParentGrid={reloadParentGrid} setClosePopupViewModal={setOpenPopupView} />}
        </div>
    )
}

export default (MasterComponentWraper(ApiDetailsFormsListings))